import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { FC, ReactNode } from 'react';

type DialogAction = {
  buttonText: string;
  onClick: () => void;
};

type Props = {
  open: boolean;
  title: string;
  content: ReactNode;
  rightAction: DialogAction;
  leftAction?: DialogAction;
};

const AlertDialog: FC<Props> = ({ open, title, content, rightAction, leftAction }) => {
  return (
    <Dialog open={open}>
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem', mb: 2 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        {leftAction && (
          <Button onClick={leftAction.onClick} variant='contained' color='error'>
            {leftAction.buttonText}
          </Button>
        )}

        <Button onClick={rightAction.onClick} variant='contained' color='primary' autoFocus>
          {rightAction.buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
